import {translations} from 'presentation/translations-new';

const {expiresIn} = translations['pt-br'].privateFlow.token;

export function formatTimeRemaining(timeRemainingInSeconds: number) {
	const hours = Math.floor(timeRemainingInSeconds / 3600);
	const minutes = Math.floor((timeRemainingInSeconds % 3600) / 60);
	const seconds = timeRemainingInSeconds % 60;

	let timeString = `${expiresIn} `;

	if (hours > 0) {
		timeString += `${hours}h `;
	}

	if (minutes > 0 || hours > 0) {
		timeString += `${minutes}m `;
	}

	timeString += `${seconds}s`;

	return timeString;
}
